require('./bootstrap');
window.AOS = require('aos/dist/aos.js');

